import { Selector } from 'reselect'
import { networkGroup } from './utils'

import {
  RootState,
} from '../../types/store'

export const initialised: Selector<RootState, boolean> = state => state.system.initialised

export const network = networkGroup('system', [
  'initialise',
])

export default {
  initialised,
  network,
}